/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iade_Iptal_S9_Li3_PreInputs */

const tr_iade_iptal_s9_li3_pre = /** @type {(inputs: Iade_Iptal_S9_Li3_PreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Müşteri Hizmetleri hattımız`)
};

const en_iade_iptal_s9_li3_pre = /** @type {(inputs: Iade_Iptal_S9_Li3_PreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Through our Customer Service line`)
};

const de_iade_iptal_s9_li3_pre = /** @type {(inputs: Iade_Iptal_S9_Li3_PreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Über unsere Kundendienstleitung`)
};

const ru_iade_iptal_s9_li3_pre = /** @type {(inputs: Iade_Iptal_S9_Li3_PreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`По нашей линии обслуживания клиентов`)
};

/**
* | output |
* | --- |
* | "Through our Customer Service line" |
*
* @param {Iade_Iptal_S9_Li3_PreInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const iade_iptal_s9_li3_pre = /** @type {((inputs?: Iade_Iptal_S9_Li3_PreInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iade_Iptal_S9_Li3_PreInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_iade_iptal_s9_li3_pre(inputs)
	if (locale === "de") return de_iade_iptal_s9_li3_pre(inputs)
	if (locale === "ru") return ru_iade_iptal_s9_li3_pre(inputs)
	return tr_iade_iptal_s9_li3_pre(inputs)
});